import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { AppSettingsService } from 'src/graphql/services/app-settings.service';
import { HintContents, HintText } from '../consts/consts';
import { Device, DeviceInfo } from '@capacitor/device';
import { from, map, Observable, shareReplay, Subject, switchMap, tap, catchError, of } from 'rxjs';

@Component({
  selector: 'app-update-modal',
  templateUrl: './update-modal.component.html',
  styleUrls: ['./update-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateModalComponent implements OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  private deviceInfo: Observable<DeviceInfo>;

  get modalContent$(): Observable<HintText> {
    return this.deviceInfo.pipe(
      map((info: DeviceInfo) => {
        switch (info.platform) {
          case 'ios':
            return HintContents.UPDATE_IOS;
          case 'android':
            return HintContents.UPDATE_ANDROID;
          default:
            return HintContents.UPDATE_OTHER
        }
      }),
      shareReplay(1),
    )
  }

  get storeLink$(): Observable<string | undefined> {
    return this.deviceInfo.pipe(
      switchMap((info: DeviceInfo) => this.appSettingsService.getStoreLink(info.platform)),
      tap((link) => console.log('[UpdateModal] Store link:', link)),
      shareReplay(1),
    )
  }

  constructor(
    private appSettingsService: AppSettingsService,
    private cdr: ChangeDetectorRef,
  ) {
    this.deviceInfo = from(Device.getInfo()).pipe(
      tap((info) => console.log('[UpdateModal] Device info:', info)),
      catchError((error) => {
        console.error('[UpdateModal] Device.getInfo() failed:', error);
        // Fallback to web platform on error
        return of({ platform: 'web' } as DeviceInfo);
      }),
      shareReplay(1)
    );
  }

  public ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.unsubscribe();
  }

  public updateClick(link: string) {
    window.open(link, '_blanc');
  }

  public refreshClick() {
    window.location.reload();
  }
}
